<template>
    <ul class="nav nav-tabs" role="tablist" :id="e.controlId">
        <template v-for="(r, index) in e.list" :key="r">
            <slot :r="{ item: r, controlId: e.controlId, activeIndex: e.active, index: index, disabled: isDisabled(index) }">
                <li class="nav-item" role="presentation">
                    <button class="nav-link" @click="changeTab(index)" :class="[index == e.active ? 'active': '', isDisabled(index) ? 'disabled' : '' ]" :id="'tabpane' + e.controlId + '_' + index" data-bs-toggle="tab" :data-bs-target="'#tab' + e.controlId + '_' + index" type="button" role="tab" :aria-controls="'tab' + e.controlId + '_' + index" aria-selected="false" v-html="r"></button>
                </li>
            </slot>            
        </template>
    </ul>
    <div class="tab-content" v-if="this.e.active > -1">
        <template v-for="(r, index) in e.list" :key="r">
            <div :id="'tab' + e.controlId + '_' + index" class="tab-pane fade" :class="[index == e.active ? 'show active': '' ]" role="tabpanel" :aria-labelledby="'tabpane' + e.controlId + '_' + index">
                <slot :name="'t' + index"></slot>
            </div>
        </template>
    </div>
</template>
<script>
    import { C } from "@/helpers/global";

    let _uid = 1;
    export default {
        name: "Tabs",
        inheritAttrs: false,
        props: {
            list: {
            },
            disabled: {
            }, 
            active: {
                default: 0
            },
        },
        emits: ['change'],
        watch: {
            list(n) {
                if (typeof (n) === 'string') {
                    n = n.split(',');
                }
                this.e.list = n;
            },
            disabled(n) {
                if (typeof (n) === 'string') {
                    n = n.split(',');
                }
                this.e.disabled = n;
            },
            active(n) {
                this.e.active = n;
            }
        },
        data() {
            return {
                e: {
                    controlId: null,
                    active: C.Int(this.active),
                    list: typeof (this.list) === 'string' ? this.list.split(',') : this.list,
                    disabled: typeof (this.disabled) === 'string' ? this.disabled.split(',') : this.disabled,
                },
            };
        },  
        methods: {
            changeTab(index) {
                //if (this.e.active = index) {
                    this.$emit('change', index);
                //}
            },
            isDisabled(index) {
                if (this.e.disabled) {
                    for (let i = 0; i < this.e.disabled.length; i++) {
                        if (this.e.disabled[i] == index) {
                            return true;
                        }
                    }
                }
                return false;
            }
        },
        mounted() {
            this.e.controlId = 'c_' + _uid;
            _uid++;
        }
    };
</script>